export default "__VITE_ASSET__CMGpyqPk__"